"use client";
import React from 'react';
import { getYouTubeEmbeddedUrl } from '@/app/utils/commonUtils';
interface VideoSectionProps {
    data: {
        href: string;
        title: string;
        description: string;
    };
}


const VideoSection = (props: VideoSectionProps) => {
    const { data } = props;

    return (
        <div className="py-20 px-6 max-w-4xl mx-auto text-center">
            <div className="relative w-full pb-[56.25%] mb-6">
                <iframe
                    src={getYouTubeEmbeddedUrl(data.href ||'')}
                    className="absolute top-0 left-0 w-full h-full rounded-xl shadow-md"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
            <h2 className="text-3xl font-bold text-[#032d60] mb-2">
                {data.title}
            </h2>
            <p className="text-[#032d60] text-lg">{data.description}</p>
        </div>
    )
}

export default VideoSection